import cn from 'classnames';
import React, { FC } from 'react';
import { Card } from 'react-bootstrap';
import { IDropdownMenuItem } from 'src/components/DropdownMenu/DropdownMenu.interface';
import { Loader } from 'src/components/Loader';
import { WidgetHeader } from 'src/components/WidgetHeader/WidgetHeader';
import { IWidgetHeaderButton, IWidgetHeaderButtonRender } from 'src/components/WidgetHeader/WidgetHeader.interface';
import { WidgetError } from '../widget-error/WidgetError';

export interface IWidgetBaseProps {
  col?: number;
  title: string | JSX.Element;
  buttons?: (IWidgetHeaderButton | IWidgetHeaderButtonRender)[];
  dropdownItems?: IDropdownMenuItem[];
  isLoading?: boolean;
  isEmpty?: boolean;
  hasError?: boolean;
  isShown?: boolean;
  className?: string;
}

export const WidgetBase: FC<IWidgetBaseProps> = ({
  title,
  children,
  col = 12,
  buttons,
  dropdownItems,
  isLoading,
  isEmpty,
  hasError,
  isShown = true,
  className,
}) => {
  if (!isShown) {
    return null;
  }

  let Content = children;

  if (isLoading) {
    Content = <Loader />;
  } else if (hasError) {
    Content = <WidgetError />;
  } else if (isEmpty) {
    Content = <p className="text-center">Нет данных</p>;
  } else {
    Content = children;
  }

  return (
    <Card className={cn(!!col && `col-md-${col}`, 'mb-4', className)} style={{ padding: 0 }}>
      <WidgetHeader title={title} headerButtons={buttons} dropdownItems={dropdownItems} isLoading={isLoading} />
      {/* eslint-disable-next-line no-nested-ternary */}
      <Card.Body className="pt-4 pb-3 px-0">{Content}</Card.Body>
    </Card>
  );
};
